'use strict';

var badge = {};

exports.__exports = badge;
//# sourceMappingURL=badge2.cjs.map
